exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-area .news-area .news-head[data-v-9a228e22]{position:relative;z-index:100;margin-top:-1rem}.content-area .news-area .news-head-bg-line[data-v-9a228e22]{position:absolute;bottom:0;left:0;background-repeat:no-repeat;height:70%;background:url(" + require("assets/info_top_frame.png") + ");background-size:100% 100%;transform:translateY(0) translateX(0)}.content-area .news-area .news-head-bg-line-center[data-v-9a228e22]{position:absolute;height:10px;left:50%;width:8rem;top:0;background-color:#fff;transform:translateY(0) translateX(-50%);border:none}.content-area .news-area .news-content[data-v-9a228e22]{border:1px solid #ccc;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9a228e22&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/DemoTop.vue
// module id = 531
// module chunks = 0